/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AbortScheduleRequestDto } from '../models/AbortScheduleRequestDto';
import type { CalculatedProductionPlanDto } from '../models/CalculatedProductionPlanDto';
import type { CampaignData } from '../models/CampaignData';
import type { FixedDoughBatchDto } from '../models/FixedDoughBatchDto';
import type { ProducedQuantityRow } from '../models/ProducedQuantityRow';
import type { ProductionScheduleDto } from '../models/ProductionScheduleDto';
import type { ReplanScheduleRequest } from '../models/ReplanScheduleRequest';
import type { ScheduleStatusEntry } from '../models/ScheduleStatusEntry';
import type { SchedulingResponseData } from '../models/SchedulingResponseData';
import type { SseEmitter } from '../models/SseEmitter';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductionScheduleControllerService {
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ProductionScheduleDto,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/production-schedules/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/production-schedules/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ProductionScheduleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules',
        });
    }
    /**
     * @param requestBody
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ProductionScheduleDto,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static unreleaseSchedule(
        uuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/unrelease',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static retryOptimization(
        uuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/retry',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static replanSchedule(
        uuid: string,
        requestBody: ReplanScheduleRequest,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/replan',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static releaseSchedule(
        uuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/release',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @param xSignature
     * @param xTimestamp
     * @returns any OK
     * @throws ApiError
     */
    public static handleOptimizationCallback(
        uuid: string,
        requestBody: SchedulingResponseData,
        xSignature?: string,
        xTimestamp?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/optimization-callback',
            path: {
                'uuid': uuid,
            },
            headers: {
                'X-Signature': xSignature,
                'X-Timestamp': xTimestamp,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static cancelOptimization(
        uuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/cancel',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static abortSchedule(
        uuid: string,
        requestBody?: AbortScheduleRequestDto,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-schedules/{uuid}/abort',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns SseEmitter OK
     * @throws ApiError
     */
    public static subscribeToStatusUpdates(
        uuid: string,
    ): CancelablePromise<SseEmitter> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/status-stream',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param effectiveAt
     * @returns ProducedQuantityRow OK
     * @throws ApiError
     */
    public static getProducedQuantitiesUntil(
        uuid: string,
        effectiveAt: string,
    ): CancelablePromise<Array<ProducedQuantityRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/produced-quantities-until',
            path: {
                'uuid': uuid,
            },
            query: {
                'effectiveAt': effectiveAt,
            },
        });
    }
    /**
     * @param uuid
     * @returns string OK
     * @throws ApiError
     */
    public static getPlanningType(
        uuid: string,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/planning-type',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns string OK
     * @throws ApiError
     */
    public static getFrozenZoneWindow(
        uuid: string,
    ): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/frozen-zone-window',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param effectiveAt
     * @returns FixedDoughBatchDto OK
     * @throws ApiError
     */
    public static getFixedDoughBatchesUntil(
        uuid: string,
        effectiveAt: string,
    ): CancelablePromise<Record<string, Array<FixedDoughBatchDto>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/fixed-dough-batches-until',
            path: {
                'uuid': uuid,
            },
            query: {
                'effectiveAt': effectiveAt,
            },
        });
    }
    /**
     * @param uuid
     * @returns CampaignData OK
     * @throws ApiError
     */
    public static getCampaigns(
        uuid: string,
    ): CancelablePromise<Array<CampaignData>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/campaigns',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns CalculatedProductionPlanDto OK
     * @throws ApiError
     */
    public static getCalculatedProductionScheduleById(
        uuid: string,
    ): CancelablePromise<CalculatedProductionPlanDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/{uuid}/calculated',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param orderUuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static getSchedulesByOrder(
        orderUuid: string,
    ): CancelablePromise<Array<ProductionScheduleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/order/{orderUuid}',
            path: {
                'orderUuid': orderUuid,
            },
        });
    }
    /**
     * @param orderUuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static getLatestScheduleByOrder(
        orderUuid: string,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/order/{orderUuid}/latest',
            path: {
                'orderUuid': orderUuid,
            },
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @param optimizationType
     * @param orderUuids
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static getOptimizedSchedule(
        startDate?: string,
        endDate?: string,
        optimizationType?: string,
        orderUuids?: Array<string>,
    ): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/optimize',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'optimizationType': optimizationType,
                'orderUuids': orderUuids,
            },
        });
    }
    /**
     * @param plannedStart
     * @param plannedEnd
     * @returns any OK
     * @throws ApiError
     */
    public static getLongTermFollowUpOrdersPreview(
        plannedStart: string,
        plannedEnd: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/long-term-follow-up-orders-preview',
            query: {
                'plannedStart': plannedStart,
                'plannedEnd': plannedEnd,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static debugResources(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/debug/resources',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static debugAllSchedules(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/debug/all',
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @param optimizationType
     * @param orderUuids
     * @returns CalculatedProductionPlanDto OK
     * @throws ApiError
     */
    public static getCalculatedProductionSchedule(
        startDate?: string,
        endDate?: string,
        optimizationType?: string,
        orderUuids?: Array<string>,
    ): CancelablePromise<CalculatedProductionPlanDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/calculated',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'optimizationType': optimizationType,
                'orderUuids': orderUuids,
            },
        });
    }
    /**
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static getActiveSchedule(): CancelablePromise<ProductionScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/active',
        });
    }
    /**
     * @returns ScheduleStatusEntry OK
     * @throws ApiError
     */
    public static getActiveStatuses(): CancelablePromise<Array<ScheduleStatusEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-schedules/active-statuses',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBatch(
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/production-schedules/batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
